import React, {useState} from "react";
import { Box, Divider, Typography } from '@mui/material';
import FormularioInfoInicio from "../pages/Main/FormularioInfoInicio";
import ListaInfoInicio from "../pages/Main/ListaInfoInicio";
import FormularioCaracteristicasProducto from "../pages/Main/FormularioCaracteristicasProducto";
import ListaCaracteristicasProducto from "../pages/Main/ListaCaracteristicasProducto";
import FormularioInfoCaracteristicasProducto from "../pages/Main/FormularioInfoCaracteristicasProducto";
import ListaInfoCaracteristicasProducto from "../pages/Main/ListaInfoCaracteristicasProducto";
import FormularioInfoResumenProducto from "../pages/Main/FormularioInfoResumenProducto";
import ListaInfoResumenProductoWeb from "../pages/Main/ListaInfoResumenProductoWeb";
import FormularioResumenProducto from "../pages/Main/FormularioResumenProducto";
import ListaResumenProducto from "../pages/Main/ListaResumenProducto";
import Hero from "../../components/Hero";
import Features from "../../components/features";
import MisDiseños from "../../components/MisDiseños";
import MisVideos from "../../components/MisVideos";
import UploadVideoBackgraoundHero from "../../components/UploadVideoBackgraoundHero";
import VideoListFondo from "../../components/VideoListFondo";
import FormularioCardCaracteristicasProducto from "../pages/Main/FormularioCardCaracteristicasProducto";
import ListaCardCaracteristicasProducto from "../pages/Main/ListaCardCaracteristicasProducto";
import MisApp from "../../components/MisApp";
import FormularioFotosSlidesMisApp from "../pages/Main/FormularioFotosSlidesMisApp";
import ListaImagenesMisApp from "../pages/Main/ListaImagenesMisApp";
import FormularioFotosListaMisdiseños from "../pages/Main/FormularioFotosListaMisdiseños";
import ListaImagenesMisDiseños from "../pages/Main/ListaImagenesMisDiseños";
import UploadMisVideos from "../pages/Main/UploadMisVideos";
import ListaMisVideosDashboard from "../pages/Main/ListaMisVideosDashboard";
import FormularioInfoMiMusica from "../pages/Main/FormularioInfoMiMusica";
import MiMusica from "../../components/MiMusica";
import ListaInfoMiMusica from "../pages/Main/ListaInfoMiMusica";
import UploadAudioForm from "../pages/Main/UploadAudioForm";
import ListAudioForm from "../pages/Main/ListAudioForm";

const DashboardInicioWeb = () => {
    const [infoInicioSeleccionado, setInfoInicioSeleccionado] = useState(null);
    const [infoCaracteristicaProductoSeleccionado, setInfoCaracteristicaProductoSeleccionado] = useState(null);
    const [infoCaracteristicaProductoWeb, setInfoCaracteristicaProductoWeb] = useState(null);
    const [infoResumenProductoWeb, setInfoResumenProductoWeb] = useState(null);
    const [infoResumenProducto, setInfoResumenProducto] = useState(null);  // Estado para guardar la URL del video
    const [infoCardCaracteristicaProductoSeleccionado, setInfoCardCaracteristicaProductoSeleccionado] = useState(null);
    const [videoUrl, setVideoUrl] = useState('');
    const [fotosSliderMisApp, setFotosSliderMisApp] = useState(null);
    const [fotosListaMisDiseños, setFotosListaMisDiseños] = useState(null);
    const [uploadMisVideos, setUploadMisVideos] = useState(null);
    const [infoMimusicaWeb, setInfoMimusicaWeb] = useState(null);
    const [uploadAudioFrom, setUploadAudioFrom] = useState(null);


    // Función para manejar la edición del infoinicio
    const handleEditarInfoInicio = (infoinicio) => {
        setInfoInicioSeleccionado(infoinicio);
    };

    // Función para manejar la edición del infoinicio
    const handleEditarCaracteristicaProducto = (infocaracteristicaproducto) => {
        setInfoCaracteristicaProductoSeleccionado(infocaracteristicaproducto);
    };

    // Función para manejar la edición del infoinicio
    const handleEditarCaracteristicaProductoWeb = (infocaracteristicaproductoweb) => {
        setInfoCaracteristicaProductoWeb(infocaracteristicaproductoweb);
    };

    // Función para manejar la edición del infoinicio
    const handleEditarResumenProductoWeb = (inforesumenproductoweb) => {
        setInfoResumenProductoWeb(inforesumenproductoweb);
    };

    // Función para manejar la edición del infoinicio
    const handleEditarResumenProducto = (inforesumenproducto) => {
        setInfoResumenProducto(inforesumenproducto);
    };

    //Funcion para manejar las tarjetas de los features
    const handleEditarCardCaracteristicasProducto = (infocardcaracteristicaproductoseleccionado) => {
        setInfoCardCaracteristicaProductoSeleccionado(infocardcaracteristicaproductoseleccionado);
    }

    //Funcion para manejar los cambios de las fotos subidas a la seccion mis app
    const handleEditarFotosSliderMisApp = (fotosslidermisapp) => {
        setFotosSliderMisApp(fotosslidermisapp);
    };

    //funcion para manejar los cambios de las fotos de la seccion mis diseños
    const handleEditarListaFotosMisDiseñosWeb = (fotoslistamisdiseños) => {
        setFotosListaMisDiseños(fotoslistamisdiseños);
    }

    //Fun cion para manejar los cambios de la lista de videos
    const handleEditarMisVideos = (listamisvideos) => {
        setUploadMisVideos(listamisvideos);
    }

    //funcion para manejar los cambios de la informacion de la seccion de mi musica
    const handleEditarMiMusicaWeb = (infomimusicaweb) => {
        setInfoMimusicaWeb(infomimusicaweb);
    }

    //Funcion para manejar los cambios de la lista de los audios subidos
    const handleEditarUploadAudioFrom = (uploadaudiofrom) => {
        setUploadAudioFrom(uploadaudiofrom);
    }

    return(
        <Box sx={{
            gap: '20px',
            margin: '10px 5px',
            textAlign: 'center',
            '@media (max-width: 600px)': {  // En móviles
                flexDirection: 'column', // Asegurarse que esté en columna
                width: '95%',
                gap: '20px',
                margin: '1% 5%',
            },
        }}>
            <Box 
                sx={{ 
                    display: 'flex', 
                    flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                    gap: '20px',
                    margin: '3% 0%',
                }}
            >
                <Typography 
                    variant='h5' 
                    sx={{ 
                        width: 'auto',
                        alignItems: 'center',
                        textAlign: 'center',
                        '@media (max-width: 600px)': {  // Ajustes para móviles
                            fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                            margin: '1% 5%',
                        },
                    }}
                >
                    Sección Hero
                </Typography>

                <Divider 
                    sx={{
                        backgroundColor: '#8E0505',
                        width: '100%', // El ancho se ajusta a todo el espacio disponible
                        height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                        margin: '1% 0%',
                        borderWidth: '0.1px',
                    }} 
                />

                <Box 
                    sx={{ 
                        display: 'flex', 
                        flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                        gap: '20px',
                        alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                        '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                            flexDirection: 'column',  // Forzar a que los elementos estén en columna
                            alignItems: 'center',
                        },
                        '@media (max-width: 600px)': {  // En móviles
                            flexDirection: 'column', // Asegurarse que esté en columna
                            width: '100%',
                            alignItems: 'center',
                        },
                    }}
                >
                    {/* Formulario para agregar el contenido a la página web */}
                    <FormularioInfoInicio infoInicioSeleccionado={infoInicioSeleccionado} />

                    {/* Lista de la información que se muestra en la página de handleEditarInfoInicio */}
                    <ListaInfoInicio onEditar={handleEditarInfoInicio} />
                </Box>

                <Hero />  {/* Este componente también debe ser responsivo */}
            </Box>


            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
             }}>
                <Typography variant='h5' marginTop={'5%'} sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}>Sección Features</Typography>
                <Divider
                    sx={{
                        backgroundColor: '#8E0505',
                        width: '100%', // El ancho se ajusta a todo el espacio disponible
                        height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                        margin: '1% 0%',
                        borderWidth: '0.1px',
                    }} 
                />

                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                        gap: '15px',  // Reducir el espacio entre los elementos
                    },
                }}>
                    {/*Formulario para agregar el contenido a la página web */}
                    <FormularioCaracteristicasProducto infoCaracteristicaProductoSeleccionado={infoCaracteristicaProductoSeleccionado}/>

                    {/*Lista de la información de los caracteres del producto */}
                    <ListaCaracteristicasProducto onEditar={handleEditarCaracteristicaProducto}/>
                </Box>

                <Features />

                <Typography variant='h5' sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}>Lista Card de features</Typography>

                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                        gap: '15px',  // Reducir el espacio entre los elementos
                    },
                 }}>
                    <FormularioCardCaracteristicasProducto infoCardCaracteristicaProductoSeleccionado={infoCardCaracteristicaProductoSeleccionado}/>

                    {/*handleEditarCardCaracteristicasProducto */}
                    <ListaCardCaracteristicasProducto infoCardCaracteristicaProductoSeleccionado={handleEditarCardCaracteristicasProducto} />
                </Box>

            </Box>

            {/*Lista de mis app normales y subir los app de muestra de la seccion mis app */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
             }}>
                <Typography variant='h5' marginTop={'5%'} sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}>Sección Mis App</Typography>
                <Divider sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }}/>

                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                        gap: '15px',  // Reducir el espacio entre los elementos
                    },
                 }}>

                    {/*Formulario Para agregar la informacion a la sesion de FormularioInfoCaracteristicasProducto */}
                    <FormularioInfoCaracteristicasProducto infoCaracteristicaProductoWeb={infoCaracteristicaProductoWeb} />
                    
                    
                    {/*Lista para modificar la informacion de la sesion caracteristica del prodcuto */}
                    <ListaInfoCaracteristicasProducto onEditar={handleEditarCaracteristicaProductoWeb}/>
                </Box>

                <Typography variant='h5' marginTop={'5%'} sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}>Mis app diseñadas</Typography>
                <Divider sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }}/>

                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                    },
                 }}>
                    <FormularioFotosSlidesMisApp fotosSliderMisApp={fotosSliderMisApp}/>

                    <ListaImagenesMisApp onEditar={handleEditarFotosSliderMisApp}/>
                </Box>
                
                <MisApp />
            </Box>

            {/*Lista de mis musica normales y subir los musica de muestra de la seccion mis musica */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
             }}>
                <Typography variant='h5' sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}>Sección Mi música</Typography>

                <Divider sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }}/>
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                        gap: '15px',  // Reducir el espacio entre los elementos
                    },
                 }}>
                    <FormularioInfoMiMusica infoMimusicaWeb={infoMimusicaWeb}/>

                    <ListaInfoMiMusica onEditar={handleEditarMiMusicaWeb} />
                </Box>
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                        gap: '15px',  // Reducir el espacio entre los elementos
                    },
                 }}>
                    <UploadAudioForm uploadAudioFrom={uploadAudioFrom} />

                    <ListAudioForm onEditar={handleEditarUploadAudioFrom} />
                </Box>

                <MiMusica />
            </Box>

            {/*Lista de mis diseños normales y subir los diseños de muestra de la seccion mis diseños */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
             }}>
                <Typography variant='h5' marginTop={'5%'} sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}>Sección Mis Diseños</Typography>
                <Divider sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }}/>

                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                        gap: '15px',  // Reducir el espacio entre los elementos
                    },
                 }}>
                    {/*Formulario para agregar la información en la seccion del resumen del producto */}
                    <FormularioInfoResumenProducto infoResumenProductoWeb={infoResumenProductoWeb}/>

                    {/*Lista para mostrar la informacion del resumen del producto en dicha secion */}
                    <ListaInfoResumenProductoWeb onEditar={handleEditarResumenProductoWeb}/>
                </Box>

                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                    },
                 }}>
                    <FormularioFotosListaMisdiseños fotosListaMisDiseños={fotosListaMisDiseños} />
                    <ListaImagenesMisDiseños onEditar={handleEditarListaFotosMisDiseñosWeb} />
                </Box>

                <MisDiseños />
            </Box>

            {/*Lista de mis videos normales y subir los videos de muestra de la seccion mis videos */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
             }}>
                <Typography variant='h5' marginTop={'5%'} sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}>Sección Mis Videos</Typography>
                <Divider sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }}/>
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                        gap: '15px',  // Reducir el espacio entre los elementos
                    },
                 }}>
                    {/*Formulario para agregar la información a las tarjetas de resumen del producto */}
                    <FormularioResumenProducto infoResumenProducto={infoResumenProducto}/>

                    {/*Lista para mostrar la informacion de las tarjetas de resumen del producto en dicha secion */}
                    <ListaResumenProducto onEditar={handleEditarResumenProducto} />
                </Box>

                <MisVideos />
            </Box>

            {/*Lista de videos y subir en la seccion de los videos */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
             }}>
                <Typography variant='h5' marginTop={'5%'} sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}>Videos de la seccion mis videos</Typography>
                <Divider sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }}/>

                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                        gap: '15px',  // Reducir el espacio entre los elementos
                    },
                }}>
                    <UploadMisVideos uploadMisVideos={uploadMisVideos}/>
                </Box>

                <ListaMisVideosDashboard onEditar={handleEditarMisVideos} />
            </Box>

            {/*Lista de videos y subir los videos de fondo de hero */}
            <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column', // En pantallas pequeñas, columna, en otras también columna
                gap: '20px',
                margin: '3% 0%',
             }}>
                <Typography variant='h5' marginTop={'5%'} sx={{ 
                    width: 'auto',
                    alignItems: 'center',
                    textAlign: 'center',
                    '@media (max-width: 600px)': {  // Ajustes para móviles
                        fontSize: '1.25rem',  // Tamaño más pequeño para la tipografía
                        margin: '1% 5%',
                    },
                }}>Videos de fondo</Typography>
                <Divider sx={{
                    backgroundColor: '#8E0505',
                    width: '100%', // El ancho se ajusta a todo el espacio disponible
                    height: '0%',  // Puede ajustar el grosor aquí, aunque este valor es 0
                    margin: '1% 0%',
                    borderWidth: '0.1px',
                }}/>
                <Box sx={{ 
                    display: 'flex', 
                    flexDirection: { xs: 'column', sm: 'row' },  // Para pantallas pequeñas: columna, en tablets o más grandes: fila
                    gap: '20px',
                    alignItems: 'center',  // Centrar elementos verticalmente cuando en fila
                    '@media (max-width: 1024px)': {  // En tablets o pantallas más pequeñas
                        flexDirection: 'column',  // Forzar a que los elementos estén en columna
                        alignItems: 'center',
                    },
                    '@media (max-width: 600px)': {  // En móviles
                        flexDirection: 'column', // Asegurarse que esté en columna
                        gap: '15px',  // Reducir el espacio entre los elementos
                    },
                 }}>
                    {/* Pasar setVideoUrl correctamente como prop */}
                    <UploadVideoBackgraoundHero setVideoUrl={setVideoUrl} />
                </Box>

                {/* Pasar videoUrl como prop a VideoPlay */}
                <VideoListFondo videoUrl={videoUrl} />

            </Box>
        </Box>
    );
};

export default DashboardInicioWeb;